import React, { useEffect, useState } from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import {
  CollapseClose,
  CollapseCloseWhiteIcon,
  CollapseOpen,
  CollapseOpenWhiteIcon,
} from "../../../assets/images";
import GstrThreeBTable from "../GstrForms/GstrThreeBTable/GstrThreeBTable";
import { GstrThreeBDataType } from "../../../commonTypes/gstTypes";
type AppProps = {
  data: any;
  settingData: Function;
  type: string;
  gstrThreeBData: GstrThreeBDataType | {};
};
const GstAccordian = ({
  data,
  settingData,
  type,
  gstrThreeBData,
}: AppProps) => {
  const [iterableGstrData, setIterableGstrData] = useState<any>([]);

  useEffect(() => {
    if (data?.length) {
      let finalData: any[] = JSON.parse(JSON.stringify(data));
      setIterableGstrData([...finalData]);
    }
  }, [data]);

  function handleData(item: any, type: string) {
    switch (type) {
      case "gstrthreeb":
        return <GstrThreeBTable item={item} gstrThreeBData={gstrThreeBData} />;
      default:
        return "";
    }
  }

  const handleToggleAccordianClick = (id: any) => {
    iterableGstrData?.map((elem: any) => {
      if (elem.id === id) {
        elem.isOpen = !elem.isOpen;
      }
    });
    settingData([...iterableGstrData]);
  };
  return (
    <>
      {iterableGstrData?.map((item: any) => {
        return (
          <div className="col-md-12">
            <>
              <div className="accordian">
                <>
                  {item.isOpen ? (
                    <img
                      width="20px"
                      onClick={() => handleToggleAccordianClick(item.id)}
                      style={{ cursor: "pointer" }}
                      src={type ? CollapseOpenWhiteIcon : CollapseOpen}
                      className="accordion-arrow"
                      alt="accordion-arrow"
                    />
                  ) : (
                    <img
                      width="20px"
                      onClick={() => handleToggleAccordianClick(item.id)}
                      style={{ cursor: "pointer" }}
                      src={type ? CollapseCloseWhiteIcon : CollapseClose}
                      className="accordion-arrow"
                      alt="accordion-arrow"
                    />
                  )}
                </>
                {item?.header}
              </div>
              {item.isOpen && <div>{handleData(item, type)}</div>}
            </>
          </div>
        );
      })}
    </>
  );
};

export default GstAccordian;
